<!-- <div class="profile-container">
    <div class="">
        <div class="profile-content">

            <div class="personal-details">
                <div class="row">
                    <p>User Tickets</p>
                </div>
                <div class="row">
                    <div class="col-md-7 col-lg-7">
                        <div class="col-md-6 col-lg-6">
                            <select class="form-control" [(ngModel)]="userId">
                                <option value="" disable selected hidden>---select user---</option>
                                <option *ngFor="let user of usersList" [value]="user.userId">{{user.userName}}</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-md-5 col-lg-5" style="display: flex;padding-left: 0;justify-content: space-between;">
                        <div class="" style="width:39%">
                            <input type="date" [(ngModel)]="startDate" class="form-control">
                        </div>
                        <div class="" style="width:39%">
                            <input type="date" [(ngModel)]="endDate" class="form-control">
                        </div>
                        <div class="" style="width:20%">
                            <button (click)="getFilteredData(0,10)" class="btn btn-primary">search</button>
                        </div>
                    </div>
                </div>
                <table class="table table-striped" *ngIf="filteredData != 0">
                    <thead>
                      <tr>
                        <th scope="col">Type Name</th>
                        <th scope="col">Assigned To</th>
                        <th scope="col">Description</th>
                        <th scope="col">Subject</th>
                        <th scope="col">Status</th>

                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let filteredData of filteredData;let i = index">
                        <th scope="col">{{filteredData.typeName}}</th>
                        <th scope="col">{{filteredData.assignedToUserName}}</th>
                        <th scope="col">{{filteredData.details}}</th>
                        <th scope="col">{{filteredData.heading}}</th>
                        <th scope="col">{{filteredData.latestTicketStatus}}</th>
                      </tr>
                    </tbody>
                </table>
            </div>

        </div>
    </div>
</div> -->


<div class="profile-container">
    <div class="">
        <div class="profile-content">
          <!-- <button class="add-Ticket-controller" data-toggle="modal" data-target="#exampleModal">Add Ticket</button> -->
            <div class="row">
              <!-- <div class="col-lg-3 col-md-3 dataListStatus">
                <ul>
                  <li><h4>Ticket Status</h4></li>
                  <li>All Ticket<span class="New">{{newTicketCount}}</span></li>
                  <li>New <span class="New">{{newTicketCount}}</span></li>
                  <li>Work In Progress <span class="Work-In-Progress">5</span></li>
                  <li>Pending <span class="Pending">2</span></li>
                  <li>Completed <span class="Completed">10</span></li>
                  <li>Deferred <span class="Deferred">5</span></li>
                </ul>
              </div> -->
              <div class="col-lg-12 col-md-12 dataList" style="margin:0;padding: 0;">
                <div class="dataList-header">
                  <div class="dataList-header-left">
                    <h4>TICKETS</h4>
                  </div>
                  <div class="dataList-header-right">
                    <!-- <select name="" id="" (change)="ticketStatusDropdownChange()" class="form-control" [(ngModel)]="status">
                      <option value="ALL">ALL</option>
                      <option value="OPEN">OPEN</option>
                      <option value="COMPLETED">COMPLETED</option>
                      <option value="CLOSED">CLOSED</option>
                      <option value="UNASSIGNED">UNASSIGNED</option>
                    </select>                         -->
                    <!-- <input type="text" style="margin-left: 10px" class="form-control" placeholder="Filter here" [(ngModel)]="searchFilter"> -->
                    <input type="text" style="margin-left: 10px" class="form-control" placeholder="Filter here" [(ngModel)]="searchTicketId">
                    <button (click)="ticketById()" >search</button>
                  </div>
                </div>
                <div class="dataList-content">
                  <table class="table">
                    <thead>
                      <tr>
                        <th style="width: 5%;">Id</th>
                        <th style="width: 12%;">Customer Id</th>
                        <th style="width: 18%;">Subject</th>
                        <th style="width: 20%;">Details</th>
                        <th style="width: 15%;">Status</th>
                        <th style="width: 20%;">createdDate</th>
                        <th style="width: 10%;">Action</th>
                      </tr>
                    </thead>
                   
                    <!-- <tbody>
                      <tr *ngFor="let ticket of data | filter: searchFilter | paginate : {
                          itemsPerPage: tableSize,
                          currentPage: page,
                          totalItems: count
                        }">
                        <td>{{ticket.ticketId}}</td>
                        <td>{{ticket.customerID}}</td>
                        <td>{{ticket.heading}}</td>
                        <td title="{{ticket.details}}">{{ticket.details  | slice:0:40}}</td>                      
                        <td>{{ticket.latestTicketStatus}}</td>
                        <td>{{ticket.createdDate | date:'medium'}}</td>
                        <td>
                          <svg xmlns="http://www.w3.org/2000/svg"  (click)="del(ticket.id)" data-toggle="modal" data-target="#deleteModal"    width="18" height="18" fill="currentColor" class="bi bi-trash3" viewBox="0 0 16 16">
                            <path d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5ZM11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H2.506a.58.58 0 0 0-.01 0H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1h-.995a.59.59 0 0 0-.01 0H11Zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5h9.916Zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47ZM8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5Z"/>
                          </svg>
  
                          <svg xmlns="http://www.w3.org/2000/svg" id="" (click)="getTicketTaskByID(ticket.ticketId)" data-toggle="modal" data-target="#ticketview"   width="18" height="18" fill="currentColor" class="bi bi-eye-fill" viewBox="0 0 16 16">
                            <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z"/>
                            <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8zm8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z"/>
                          </svg> 
  
                          <svg xmlns="http://www.w3.org/2000/svg" (click)="Ticketid(ticket.ticketId,ticket.details,ticket.heading)" data-toggle="modal" data-target="#ticket" width="16" height="16" fill="currentColor" class="bi bi-align-middle" viewBox="0 0 16 16">
                            <path d="M6 13a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v10zM1 8a.5.5 0 0 0 .5.5H6v-1H1.5A.5.5 0 0 0 1 8zm14 0a.5.5 0 0 1-.5.5H10v-1h4.5a.5.5 0 0 1 .5.5z"/>
                          </svg>
                        </td>
                      </tr>
                    </tbody> -->
                  </table>
                  <!-- <div class="pagination-block" *ngIf="data.length != 0">
                    <pagination-controls
                      previousLabel="Prev"
                      nextLabel="Next"
                      (pageChange)="onTableDataChange($event)"
                    >
                    </pagination-controls>
                  </div> -->
  
                  <div class="ticket-block-data" *ngFor="let ticket of data | filter: searchFilter | paginate : {
                    itemsPerPage: tableSize,
                    currentPage: pageNumber1,
                    totalItems: totalRecords
                    }">
                    <div class="ticket-header-block">
                      <span style="width: 5%;padding: 8px;">{{ticket.ticket.ticketId}}</span>
                      <span style="width: 12%;padding: 8px;">{{ticket.ticket.customerID}} </span>
                      <span style="width: 18%;padding: 8px;">{{ticket.ticket.heading}}</span>
                      <span style="width: 20%;padding: 8px;" title="{{ticket.ticket.details}}">{{ticket.ticket.details  | slice:0:30}}</span>
                      <span style="width: 15%;padding: 8px;">{{ticket.ticket.latestTicketStatus}}</span>
                      <span style="width: 20%;padding: 8px;">{{ticket.ticket.createdDate | date:'medium'}}</span>
                      <span style="width: 10%;padding: 8px;display: flex;justify-content: center;">
                        <!-- <svg xmlns="http://www.w3.org/2000/svg"  (click)="del(ticket.ticket.id)" data-toggle="modal" data-target="#deleteModal"    width="18" height="18" fill="currentColor" class="bi bi-trash3" viewBox="0 0 16 16">
                          <path d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5ZM11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H2.506a.58.58 0 0 0-.01 0H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1h-.995a.59.59 0 0 0-.01 0H11Zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5h9.916Zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47ZM8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5Z"/>
                        </svg> -->
    
                        <svg xmlns="http://www.w3.org/2000/svg" id="" style="margin: 0 10px" (click)="getTicketTaskByID(ticket.ticket.ticketId)" data-toggle="modal" data-target="#ticketview"   width="18" height="18" fill="currentColor" class="bi bi-eye-fill" viewBox="0 0 16 16">
                          <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z"/>
                          <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8zm8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z"/>
                        </svg> 
    
                        <svg xmlns="http://www.w3.org/2000/svg" (click)="Ticketid(ticket.ticket.ticketId,ticket.ticket.details,ticket.ticket.heading)" data-toggle="modal" data-target="#ticket" width="16" height="16" fill="currentColor" class="bi bi-align-middle" viewBox="0 0 16 16">
                          <path d="M6 13a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v10zM1 8a.5.5 0 0 0 .5.5H6v-1H1.5A.5.5 0 0 0 1 8zm14 0a.5.5 0 0 1-.5.5H10v-1h4.5a.5.5 0 0 1 .5.5z"/>
                        </svg>
                      </span>
                    </div>
                    <div class="ticket-tasks-b row" *ngFor="let task of ticket.taskList;let t = index">
                      <div class="col-md-2 col-lg-2">
                        <label *ngIf="t == 0" for="">Task Id</label>
                        <p>{{task.ttaskId}}</p>
                      </div>
                      <div class="col-md-3 col-lg-3">
                        <label *ngIf="t == 0" for="">Name</label>
                        <p>{{task.name}}</p>
  
                      </div>
                      <div class="col-md-2 col-lg-2">
                        <label *ngIf="t == 0" for="">Assigned To</label>
                        <p>{{task.assignedToUserName}}</p>
  
                      </div>
                      <div class="col-md-2 col-lg-2">
                        <label *ngIf="t == 0" for="">Assigned Date</label>
                        <p>{{task.latestTaskStatusDate | date}}</p>
  
                      </div>
                      <div class="col-md-2 col-lg-2">
                        <label *ngIf="t == 0" for="">Status</label>
                        <p>{{task.latestTaskStatus}}</p>
  
                      </div>
                    </div>
               
                </div>
                <!-- <div class="pagination-block" *ngIf="data.length != 0">
                    <pagination-controls
                      previousLabel="Prev"
                      nextLabel="Next"
                      (pageChange)="onTableDataChange($event)"
                    >
                    </pagination-controls>
                  </div> -->
                  <h5 class="text-center" *ngIf="data.length == 0">no tickets</h5>
                </div>
              </div>
            </div>
        </div>
    </div>
  </div>
  
  
  <div class="modal fade" id="exampleModal" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Add Ticket</h5>
      </div>
      <div class="modal-body">
  
        <div [formGroup]="form">
          <div class="row">
            <div class="col-md-6 col-lg-6">
              <div class="form-group">
                <label>Ticket Type</label>
                <select class="form-control" formControlName="typeId">
                  <option *ngFor="let x of IDs" [value]="x.id">{{x.name}}</option>
                </select>
              </div>
            </div>
            <div class="col-md-6 col-lg-6">
              <div class="form-group">
                <label>Subject</label>
                <input  type="text" formControlName="heading" class="form-control">
              </div>
            </div>
            <div class="col-md-12 col-lg-12">
              <div class="form-group">
                <label>Details</label>
                <textarea name="" class="form-control" formControlName="details" id="" cols="20" rows="10"></textarea>
              </div>
            </div>
            <div class="col-md-6 col-lg-6">
              <div class="form-group">
                <label>Customer ID</label>
                <input  type="text" formControlName="customerID" class="form-control">
              </div>
            </div>
            <div class="col-md-6 col-lg-6">
              <div class="form-group">
                <label>Customer Type</label>
                <input  type="text" formControlName="customerType" class="form-control">
              </div>
            </div>
            
          </div>
        </div>
  
   
      <div class="modal-footer">
        <button type="button" id="closeModalButton"   class="btn btn-secondary" data-dismiss="modal">Cancel</button>
        <button type="button" (click)="addcontroller()" class="btn btn-primary">Add Ticket</button>
      </div>
    </div>
  </div>
  </div>
  </div>
  
  
  <div class="modal fade" id="ticketview" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
    <div class="modal-content">
      <div class="task-content" *ngFor="let ticket of TicketData;">
        <div class="c-button">
          <div class="c-right">
            <h4>Ticket Id: #{{ticket.ticketId}}</h4>
            <!-- <div class="task-status-bar">
              <ul>
                <li class="activeStatus" (click)="activeStatus('All')" id="All">All</li>
                <li id="New">New</li>
                <li id="Completed">Completed</li>
                <li id="Pending">Pending</li>
                <li id="Canceled">Canceled</li>
              </ul>
            </div> -->
          </div>
          <div style="align-items: center;">
            <!-- <input type="text" name="" id=""> -->
            <!-- <svg  xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="currentColor" class="bi bi-chat-left-dots" viewBox="0 0 16 16">
              <path d="M14 1a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H4.414A2 2 0 0 0 3 11.586l-2 2V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12.793a.5.5 0 0 0 .854.353l2.853-2.853A1 1 0 0 1 4.414 12H14a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"/>
              <path d="M5 6a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm4 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm4 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"/>
            </svg> -->
            <svg data-toggle="modal" data-target="#taskAddModel" xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="currentColor" class="bi bi-plus-circle" viewBox="0 0 16 16">
              <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
              <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
            </svg>
            <svg (click)="insertConversation()" xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="currentColor" class="bi bi-chat-left-dots" viewBox="0 0 16 16">
              <path d="M14 1a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H4.414A2 2 0 0 0 3 11.586l-2 2V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12.793a.5.5 0 0 0 .854.353l2.853-2.853A1 1 0 0 1 4.414 12H14a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"/>
              <path d="M5 6a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm4 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm4 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"/>
            </svg>
            <svg xmlns="http://www.w3.org/2000/svg" style="margin-left: 10px" data-dismiss="modal" width="26" height="26" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
              <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
            </svg>
          </div>
        </div>
       <div class="task-data">
        <ul class="task-header1">
          <li style="width: 20%;">Customer ID	</li>
          <li style="width: 20%;">Service Type</li>
          <li style="width: 20%;">Subject</li>
          <!-- <li style="width: 25%;">Details	</li> -->
        
          <li style="width: 20%;">Status</li>
        </ul>
        <div class="task-table" style="margin-bottom: 10px;" >
          <ul>
            <li style="width: 20%;">{{ticket.customerID}}</li>
            <li style="width: 20%;">{{ticket.customerType}}</li>
            <li style="width: 20%;">{{ticket.heading}}</li>
            <!-- <li style="width: 25%;">{{ticket.details}}</li> -->
            
            <li style="width: 20%;text-align: center;position: relative;background-color: white;">
              <div>
                  <p><span (click)="statusDropdown()" style="cursor: pointer;padding: 5px 10px;" class="NEW">{{ticket.latestTicketStatus}}</span></p>
                  
                  <p><span *ngIf="ticket.latestTicketStatus == 'CLOSED' || ticket.latestTicketStatus == 'COMPLETED'" (click)="reopenTicket(ticket.ticketId)" class="assignedToButton">click here to re-open</span></p>
               
                </div>
            </li>
          </ul>
        </div>
        <div class="details">
          <span>Details</span> <span>: &nbsp;</span> <span>{{ticket.details}}</span>
        </div>
        <div class="assignedToAndTags">
          <!-- <div class="assignedTo">
            <p> <span>Assign to</span> <span *ngIf="ticket.assignedTo != null || ticket.assignedTo != ''">: {{ticket.assignedToUserName}}</span> 
                <span *ngIf="ticket.assignedTo == null || ticket.assignedTo == ''" (click)="addClass('assignedTo')" class="assignedToButton"> &nbsp; click here to assign</span>
                <span *ngIf="ticket.assignedTo != null && ticket.assignedTo != ''" (click)="addClass('assignedTo')" class="assignedToButton"> &nbsp; click here to reassign</span>
           </p>
          </div> -->
          <!-- <div class="usersTaged">
            <p *ngIf="task.tagUsers.length == 0"> <span>Users taged</span> <span class="assignedToButton" (click)="addClass('usersTaged')">: &nbsp; click here to Tag Users</span></p>
            <p *ngIf="task.tagUsers.length != 0"> <span>Users taged</span> <span *ngFor="let user of task.tagUsers;let u = index"> <span *ngIf="u == 0">: &nbsp;</span>  {{user.userName}},</span></p>
          </div> -->
        </div>
        <div class="assign-and-tag-data" id="assign-and-tag-data">
          <div class="assign-to-data">
            <div class="panel panel-default assign-panel" *ngIf="addClassType == 'assignedTo'">
              <div class="panel-heading">
                <h3 class="panel-title">Assign To</h3>
                <input type="text" class="form-control" [(ngModel)]="assignInput" placeholder="search user">
              </div>
              <div class="panel-body">
                <div *ngIf="ticket.assignedToUserName == '' || ticket.assignedToUserName == null">
                  <span *ngFor="let user of usersWithoutCustomers | filter: assignInput">
                    <p (click)="AssignToUser(ticket.ticketId,user.userId,'ASSIGNED',user.userName)">{{user.userName}}</p>
                  </span>
                </div>
                <div *ngIf="ticket.assignedToUserName != ''">
                  <span *ngFor="let user of usersList | filter: assignInput">
                    <p (click)="AssignToUser(ticket.ticketId,user.userId,'REASSIGNED',user.userName)">{{user.userName}}</p>
                  </span>
                </div>
              </div>
            </div>
            <div class="panel panel-default usertags-panel" *ngIf="addClassType == 'usersTaged'">
              <div class="panel-heading">
                <h3 class="panel-title">Tag User</h3>
              </div>
              <div class="panel-body">
                <div>
                  <span *ngFor="let user of usersList">
                    <p>{{user.userName}}</p>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="dropdown-data">
          <!-- <div class="status-content" *ngIf="statusNote">
            <textarea name="" style="height: 70px" [(ngModel)]="note" placeholder="enter status note" class="form-control" id="" cols="30" rows="10"></textarea>
            <select name="" id="" (change)="taskStatusDropdown()" [(ngModel)]="taskStatus">
              <option value="WORK_IN_PROGRESS">WORK_IN_PROGRESS</option>
              <option value="PENDING">PENDING</option>
              <option value="COMPLETED">COMPLETED</option>
              <option value="DEFERRED">DEFERRED</option>
              <option value="PARTIALLY_COMPLETED">PARTIALLY_COMPLETED</option>
              <option value="FORCE_CLOSED">FORCE_CLOSED</option>
              <option value="CLOSED">CLOSED</option>
            </select>
            <button (click)="updateStatus(task.id)">update status</button>
          </div> -->
     
          <div class="dropdown-data statusDrop" id="dropS">
            <div class="status-content">
              <textarea name="" style="height: 70px" [(ngModel)]="note" placeholder="enter status note" class="form-control" id="" cols="30" rows="10"></textarea>
              
                <select style="width: 35%;" name="" (change)="ticketStatusDropdown()" [(ngModel)]="ticketStatus" id="">
                  <option value="COMPLETED">COMPLETED</option>
                  <option value="CLOSED">CLOSED</option>
                </select>
                <input *ngIf="ticketStatus == 'CLOSED'" [(ngModel)]="ticketClosingOtp" placeholder="enter otp" type="text">
           
              
              <button (click)="updateTicketStatus(ticketId)">update status</button>
            </div>
          </div>
  
          <div class="status-table">
            <table class="table">
              <thead>
                <tr>
                  <th style="width: 50%;">Note</th>
                  <th style="width: 20%;text-align: center;">Status</th>
                  <th style="width: 30%;text-align: center;">Date</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let status of ticket.ticketStatus;">
                  <td style="width: 50%;">{{status.note}}</td>
                  <td style="width: 20%;text-align: center;">{{status.ticketStatus}}</td>
                  <!-- <td style="width: 15%;">{{status.updatedDate | date}}</td> -->
                  <td style="width: 30%;text-align: center;">{{status.updatedDate | date:'medium'}}</td>
                </tr>
              </tbody>
            </table>
          </div>
  
          <div class="image-container" *ngIf="ticket.image.length != 0">
            <div class="image-header">
              <h5>Images/Videos</h5>
            </div>
            <div class="image-content-block">
              <div class="image-single" *ngFor="let image of ticket.image">
                <img src="{{image}}" data-toggle="modal" data-target="#imageView" alt="">
              </div>
              <!-- <div class="image-single" *ngFor="let video of task.video">
                <img src="assets/img/video-play-icon-hd-png.png" data-toggle="modal" data-target="#imageView" (click)="viewVideo(video)" alt="">
              </div> -->
            </div>
          </div>
  
        </div>
  
        <ul class="task-header" *ngIf="TicketTaskdata.length != 0">
          <li style="width: 9%;">Task-Id</li>
          <li style="width: 9%;">Sl No</li>
          <li>Completed %</li>
          <li>Create on</li>
          <li style="width: 20%;text-align: center;">Status</li>
          <li></li>
        </ul>
  
  
  
        <div class="task-table" *ngFor="let task of TicketTaskdata;let i = index">
          <ul>
            <li style="width: 9%;">#{{task.ttaskId}}</li>
            <li style="width: 9%;">{{task.taskSlNo}}</li>
            <li style="padding-left: 20px">{{task.completedPercentage}} %</li>
            <li>{{task.createdDate | date}}</li>
            <li style="width: 20%;text-align: center;">{{task.latestTaskStatus | titlecase}}</li>
            <li><a (click)="addc(i)"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-down" viewBox="0 0 16 16">
              <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>
            </svg></a></li>
          </ul>
          <div class="dropdown-data-show" id="{{i}}">
            <div class="assignedToAndTags">
  
              <div class="assignedTo">
                <p> 
                  <span>Assign to</span> 
                  <span *ngIf="task.assignedToUserName != null && task.assignedToUserName != ''">: &nbsp; {{task.assignedToUserName}}</span>
                  <span *ngIf="task.assignedToUserName == null || task.assignedToUserName == ''" (click)="taskSelected(task.taskId,'ASSIGNED')" data-toggle="modal" data-target="#assigntaskspopup" class="assignedToButton"> &nbsp; click here to assign</span>
                  <span *ngIf="task.assignedToUserName != null && task.assignedToUserName != ''" (click)="taskSelected(task.taskId,'REASSIGNED')" data-toggle="modal" data-target="#assigntaskspopup" class="assignedToButton"> &nbsp; click here to reassign</span>
                </p>
              </div>
              <!-- <div class="usersTaged">
                <p> <span>Users taged</span> <span *ngFor="let user of task.tagUsers;let u = index"> <span *ngIf="u == 0">: &nbsp;</span>  {{user.userName}},</span></p>
              </div> -->
            </div>
            <!-- <div class="dataTablesContent">
              <div class="left">
                <p><span>Listing number</span> <span>: &nbsp; {{task.taskListingNumber}}</span></p>
                <p><span>SI number</span> <span>: &nbsp; {{task.taskSINumber}}</span></p>
                <p><span>SL number</span> <span>: &nbsp; {{task.taskSlNo}}</span></p>
              </div>
              <div class="right">
                <p> <span>Reg id</span> <span>: &nbsp; {{task.taskRegId}}</span></p>
                <p> <span>Reg type</span> <span>: &nbsp; {{task.taskRegType}}</span></p>
              </div>
            </div> -->
            <p class="task-description"><span>Subject :</span> {{task.name}}</p>
  
            <p class="task-description"><span>Description :</span> {{task.description}}</p>
            <!-- <p class="task-description"><span>Note :</span> The lorem generator is nice but it’s code completing functionality makes it indispensable. Once you learn the syntax you can code a whole wireframe with just a few keystrokes.</p> -->
  
            <!-- <div class="taskTable">
              <div>
                <table class="table">
                  <thead>
                    <tr>
                      <th scope="col">Act duration</th>
                      <th scope="col">Act end date</th>
                      <th scope="col">Act start date</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{{task.taskActDuration | date}}</td>
                      <td>{{task.taskActEndDate | date}}</td>
                      <td>{{task.taskActStartDate | date}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
  
              <div>
                <table class="table">
                  <thead>
                    <tr>
                      <th scope="col">Exp duration</th>
                      <th scope="col">Exp end date</th>
                      <th scope="col">Exp start date</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{{task.taskExpDuration | date}}</td>
                      <td>{{task.taskExpEndDate | date}}</td>
                      <td>{{task.taskExpStartDate | date}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div> -->
  
  
          </div>
        </div>
       </div>
      </div>
      <div class="modal-footer" hidden="true">
        <button type="button" id="closeModalButton12" class="btn btn-secondary" data-dismiss="modal" class="btn btn-secondary">Cancel</button>
      </div>
    </div>
  </div>
  </div>
  
  
  <div class="modal fade" id="ticket" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">Add
            <span data-dismiss="modal">
              <svg data-dismiss="modal" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                  <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
              </svg>
            </span>
          </h5>
        </div>
        <div class="modal-body">
    
          <div [formGroup]="Taskform">
            <div class="row">
              
              <!-- <div class="col-md-12 col-lg-12">
                <div class="form-group">
                  <label>Task Name</label>
                  <input formControlName="name" type="text" class="form-control">
                </div>
              </div> -->
  
              <div class="col-md-12 col-lg-12">
                <div class="col-md-11 col-11" style="padding: 0">
                  <div class="form-group">
                    <label>Task Name</label>
                    <input formControlName="name" type="text" class="form-control">
                  </div>
                </div>
                <div class="col-md-1 col-1 task-button">
                  <div class="form-group">
                    <svg xmlns="http://www.w3.org/2000/svg" data-toggle="modal" data-target="#taskspopup" fill="currentColor" class="bi bi-plus-circle" viewBox="0 0 16 16">
                      <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                      <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
                    </svg>
                  </div>
                </div>
            </div>
  
  
  
              <div class="col-md-12 col-lg-12">
                <div class="form-group">
                  <label>Description</label>
                  <textarea name="" formControlName="description" id="" style="height: 70px"  class="form-control" cols="30" rows="10"></textarea>
                </div>
              </div>
              
  
              <div class="col-md-6 col-lg-6">
                <div class="form-group">
                  <label>Assign To</label>
                  <select class="form-control" formControlName="assignedTo">
                    <option *ngFor="let user of usersWithoutCustomers" [value]="user.userId">{{user.userName}}</option>
                  </select>
                </div>
              </div>
  
              <div class="col-md-6 col-lg-6">
                <div class="form-group ">
                  <label>Tag Users</label>
                  <ng-multiselect-dropdown
                  [placeholder]="'tag users'" [ngModelOptions]="{standalone: true}"
                  [settings]="tagUsersdropdownSettings"
                  [data]="tagUsersdropdownList"
                  [(ngModel)]="tagUsersselectedItems"
                  class="form-control"
                  style="padding: 0;border: none"
                  (onSelect)="onItemSelect($event)"
                  (onSelectAll)="onSelectAll($event)"
                  >
                  </ng-multiselect-dropdown>
                </div>
              </div>
              <div class="col-md-6 col-lg-6">
                <div class="form-group">
                  <label>Exp Start Date</label>
                  <input formControlName="taskExpStartDate" type="date" class="form-control">
                </div>
              </div>
  
              <div class="col-md-6 col-lg-6">
                <div class="form-group">
                  <label>Exp End Date</label>
                  <input formControlName="taskExpEndDate" type="date" class="form-control">
                </div>
              </div>
             
  
              
            </div>
  
    
              <div class="col-lg-12" hidden="true">
                  <label class="image-upload-container btn btn-bwm">
                      <!-- <span>Select Image</span> -->
                      <input #imageInput
                             type="file" id="add-image-btn"
                             accept="image/*" hidden="true"
                             (change)="onSelectFile($event)">
                  </label>
                </div>
                <div class=" media-content">
                    <div class="mr-2 image-btn" (click)="addImageBtn()">
                      <span>+ Add Image</span>
                    </div>
                    <div class="media-area" style="border: 1px solid #e5e5e5;border-radius: 5px;height: 80px;width: 100px;overflow: hidden;padding: 1px;" *ngFor="let image of images" class="mr-2">
                        <img src="{{image}}" width="98px" height="78px" style="border-radius: 5px;" alt="" srcset="">
                    </div>
                </div>
              
                <div class="" style="margin: 0;padding: 0;" hidden="true">
                  <label class="image-upload-container btn btn-bwm">
                      <!-- <span>Select video</span> -->
                      <input #imageInput
                            type="file" id="add-video-btn"
                            accept="video/*" hidden="true"
                            (change)="onSelectFile($event)">
                    </label>
                </div>
                <div class=" media-content">
                  <div class="mr-2 image-btn" (click)="addVideoBtn()">
                    <span>+ Add video</span>
                  </div>
                  <div class="media-area" style="border: 1px solid #e5e5e5;border-radius: 5px;overflow: hidden;height: 80px;width: 100px;padding:1px;" *ngFor="let video of videos" class="mr-2">
                      <video src="{{video}}" width="98px" height="78px" style="border-radius: 5px;" controls></video> <br/>
                  </div>
                </div>
              
                <div class="" style="margin: 0;padding: 0;" hidden="true">
                  <label class="image-upload-container btn btn-bwm">
                      <!-- <span>Select video</span> -->
                      <input #imageInput
                            type="file" id="add-audio-btn"
                            accept="audio/*" hidden="true"
                            (change)="onSelectFile($event)">
                    </label>
                </div>
                <div class=" media-content">
                  <div class="mr-2 image-btn" (click)="addAudioBtn()">
                    <span>+ Add Audio</span>
                  </div>
                  <div class="media-area" style="border: 1px solid #e5e5e5;border-radius: 5px;overflow: hidden;height: 80px;width: 100px;padding:1px;" *ngFor="let video of videos" class="mr-2">
                      <video src="{{video}}" width="98px" height="78px" style="border-radius: 5px;" controls></video> <br/>
                  </div>
                </div>
              
                <div *ngFor="let audio of audios" class="mr-2">
                  <audio controls>
                    <source src="{{audio}}" type="audio/mpeg">
                  </audio>
                </div>
            </div>
        <div class="modal-footer">
          <button type="button" id="closeModalButton3" (click)="cancelModel()" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
          <button type="button" (click)="addTicketTask()" *ngIf="addTaskButton" class="btn btn-primary">Add Task</button>
        </div>
      </div>
    </div>
    </div>
  </div>
  
  <div class="modal fade" id="taskAddModel" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
      <div class="modal-content">
        <div class="task-content">
          <div class="c-button">
            <div class="c-right">
              <h4>Tasks</h4>
            </div>
            <div style="align-items: center;">
              <svg xmlns="http://www.w3.org/2000/svg" style="margin-left: 10px" data-dismiss="modal" width="26" height="26" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
              </svg>
            </div>
          </div>
          <div class="task-data">
            <div class="task-table" *ngFor="let task of taskMasters;let j = index">
              <ul>
                <li>{{task.taskGroupName}}</li>
             
                <li style="width: 15%;display: flex;justify-content: space-between;">
                  <button (click)="addTaskMaster(j)" class="task-add-button">Add Task</button>
                  <a (click)="addc(j+999)"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-down" viewBox="0 0 16 16">
                    <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>
                    </svg>
                  </a>
                </li>
              </ul>
              <div class="dropdown-data" id="{{j+999}}">
                <div class="assignedToAndTags">
                  <div class="status-table">
                    <table class="table">
                      <thead>
                        <tr>
                          <th style="width: 20%;">SeqNo</th>
                          <th style="width: 20%;">Name</th>
                          <th style="width: 60%;">Description</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let taskGroup of task.taskGroup;">
                          <td>{{taskGroup.seqNo}}</td>
                          <td>{{taskGroup.name}}</td>
                          <td>{{taskGroup.description}}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" id="closeModalButton5" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
          </div>
      </div>
    </div>
    </div>
  </div>
  
  <div class="modal fade" id="taskspopup" tabindex="-1" data-backdrop="static" aria-labelledby="taskspopup" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">Tasks</h5>
        </div>
        <div class="modal-body">
          <div class="status-table">
            <table class="table">
              <thead>
                <tr>
                  <th style="width: 20%;">Task SlNo</th>
                  <th style="width: 20%;">Task Name</th>
                  <th style="width: 40%;">Description</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let task of TaskNameAndDescription" (click)="autoFill(task.name,task.description)">
                  <td>{{task.seqNo}}</td>
                  <td>{{task.name}}</td>
                  <td>{{task.description}}</td>
                </tr>
              </tbody>
            </table>
          </div>
      
          <div class="modal-footer">
            <button type="button" id="closeModalButton67"   class="btn btn-secondary" data-dismiss="modal">Cancel</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  
  
  <div class="modal fade" id="assigntaskspopup" tabindex="-1" data-backdrop="static" aria-labelledby="assigntaskspopup" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">Assign Task</h5>
        </div>
        <div class="modal-body">
          <div>
            <select name="" id="" class="form-control" [(ngModel)]="userId">
              <option [value]="user.userId" *ngFor="let user of usersWithoutCustomers">{{user.userName}}</option>
            </select>
          </div>
      
          <div class="modal-footer">
            <button type="button" id="closeTaskAssign" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
            <button type="button" id="closeModalButton67" class="btn btn-primary" (click)="taskAssignToUser()">Submit</button>
          </div>
        </div>
      </div>
    </div>
  </div>